
import React from 'react';
import { Button } from '@/components/ui/button';

interface CategoryNavProps {
  categories: {
    id: string;
    name: string;
  }[];
  selectedCategory: string | null;
  onCategorySelect: (categoryId: string) => void;
}

const CategoryNav: React.FC<CategoryNavProps> = ({ 
  categories, 
  selectedCategory, 
  onCategorySelect 
}) => {
  return (
    <section className="py-8 bg-pkgreen-50 border-y border-pkgreen-100 sticky top-0 z-30">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-3">
          {categories.map((category) => (
            <Button
              key={category.id}
              onClick={() => onCategorySelect(category.id)}
              variant={selectedCategory === category.id ? "default" : "outline"}
              className={`rounded-full transition-all ${
                selectedCategory === category.id
                  ? "bg-pkgreen-600 hover:bg-pkgreen-700"
                  : "border-pkgreen-600 text-pkgreen-700 hover:bg-pkgreen-50"
              }`}
            >
              {category.name}
            </Button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryNav;
